export default "__VITE_ASSET__bb1f9c59__"